import type { FC } from 'react';
import { CheckCircleIcon, ExclamationIcon, XCircleIcon } from '@heroicons/react/outline';
import clsx from 'clsx';

const ICON_STYLES = {
  valid: {
    icon: CheckCircleIcon,
    iconColor: 'text-success-600',
  },
  warning: {
    icon: ExclamationIcon,
    iconColor: 'text-warning-600',
  },
  danger: {
    icon: XCircleIcon,
    iconColor: 'text-red-600',
  },
} as const;

interface ValidationIconProps {
  type: keyof typeof ICON_STYLES;
}

export const ValidationIcon: FC<ValidationIconProps> = ({ type }) => {
  const style = ICON_STYLES[type];

  return <style.icon className={clsx('h-4 w-4', style.iconColor)} aria-hidden="true" />;
};
